import { Main } from 'components/ActionStyles/ActionStyles'
import AntdAvatar from 'components/Avatar'
import { FlexWrap } from 'components/TableStyles/TableContentStyles/TableContentStyles'
import React from 'react'
import {
  RowNumberCandidateData,
  RowNumberCandidateDataEx,
  RowNumberDataEx,
} from '../../../IndividualPage/Partials/CandidateTable/style'
import { CardsFlexNew } from '../../../Style/style'

const CandidateResumeView = ({
  student,
  studentDetailsAPI,
  getPromotion,
  setSelectedId,
  setDrawerStatus,
  status,
  questionAndAnswer,
}) => {
  const handleClick = () => {
    studentDetailsAPI(student?.id)
    getPromotion(student?.id)
    setSelectedId(student?.id)
    setDrawerStatus(status)
    questionAndAnswer(student?.id)
  }
  const fullName = `${student?.firstName || ''} ${
    student?.lastName || ''
  }`.trim()
  let displayName = ''

  if (fullName?.length > 16) {
    displayName = fullName.substring(0, 16) + '...'
  } else {
    displayName = fullName
      .split(' ')
      .map(name => name?.charAt(0).toUpperCase() + name?.slice(1))
      .join(' ')
  }

  return (
    <>
      {student?.isExpCandidate ? (
        <Main key={student?.id}>
          <FlexWrap
            alignCenter
            gap="8px"
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
          >
            <AntdAvatar
              src={student?.profileUrl}
              size={39}
              IconName={student?.firstName?.charAt(0).toUpperCase()}
            />
            <CardsFlexNew column>
              <RowNumberCandidateDataEx>{displayName}</RowNumberCandidateDataEx>
              <RowNumberDataEx>
                {student?.studentPersonalProfile?.phoneNumber}
              </RowNumberDataEx>
            </CardsFlexNew>
          </FlexWrap>
        </Main>
      ) : (
        <Main key={student?.id}>
          <FlexWrap
            alignCenter
            gap="8px"
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
          >
            <AntdAvatar
              src={student?.profileUrl}
              size={37}
              IconName={student?.firstName?.split('')[0]}
            />
            <RowNumberCandidateData>{displayName}</RowNumberCandidateData>
          </FlexWrap>
        </Main>
      )}
    </>
  )
}

export default CandidateResumeView
